import React from 'react'
import styles from "./style.module.scss"
import { Collapse } from 'antd'
import { useTranslation } from 'next-i18next'

const { Panel } = Collapse

const Faqs = () => {
    const { t } = useTranslation('common');
    const faqs = t('faqs.items', { returnObjects: true }) as {
        question: string;
        answer: string;
    }[];

    const panelStyle = {
        marginBottom: 24,
        background: "var(--card-bg)",
        borderRadius: 10,
        border: 'none',
        boxShadow: '5px 10px 30px 0px rgba(0, 0, 0, 0.05)',
    }

    return (
        <div className={styles.faqWrapper}>
            <img src="/static/img/HomePage/icon.svg" alt="icon" style={{ marginBottom: "48px" }} />
            <h3 className={styles.subtitle}>{t('faqs.subtitle')}</h3>
            <h1 className={styles.title}>{t('faqs.title')}</h1>

            <Collapse
                accordion
                bordered={false}
                expandIcon={({ isActive }) => (
                    <img
                        src="/static/img/HomePage/icon.svg"
                        alt="badge"
                        className={`${styles.custom_expand_icon} ${isActive ? styles.active : ""}`}
                    />
                )}
                style={{ background: "transparent" }}
            >
                {faqs?.map((item, idx) => (
                    <Panel
                        className={styles.accordion}
                        header={<h1 className={styles.accordionTitle}>{item.question}</h1>}
                        key={idx}
                        style={panelStyle}
                    >
                        <p className={styles.accordionText}>{item.answer}</p>
                    </Panel>
                ))}
            </Collapse>
        </div>
    )
}

export default Faqs
